import React from 'react';
import { Container, Typography, Box, Paper, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import GavelIcon from '@mui/icons-material/Gavel';
import BlockIcon from '@mui/icons-material/Block';
import { Link } from 'react-router-dom';

const CopyrightPage = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography 
        variant="h3" 
        component="h1" 
        gutterBottom 
        align="center" 
        sx={{ 
          color: '#1a1a1a', 
          mb: 6,
          fontFamily: '"Playfair Display", serif',
          fontWeight: 700
        }}
      >
        Derechos de Autor
      </Typography>

      <Paper 
        elevation={0} 
        sx={{ 
          p: 4,
          borderRadius: 4,
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box 
            sx={{ 
              p: 1.5, 
              borderRadius: '50%', 
              bgcolor: 'rgba(0, 0, 0, 0.05)', 
              mr: 2,
              display: 'flex'
            }}
          >
            <CopyrightIcon sx={{ fontSize: 28, color: 'text.secondary' }} />
          </Box>
          <Typography variant="h5" fontWeight="bold" sx={{ fontFamily: '"Playfair Display", serif' }}>
            Propiedad Intelectual
          </Typography>
        </Box>
        
        <Typography paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
          El contenido incluido en este sitio web y en nuestra aplicación móvil, incluyendo pero no limitado a texto, gráficos, logotipos, imágenes, clips de audio, descargas digitales y compilaciones de datos, es propiedad de <strong>Blüm Art</strong> o de sus proveedores de contenido y está protegido por las leyes de derechos de autor de México y tratados internacionales.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box 
            sx={{ 
              p: 1.5, 
              borderRadius: '50%', 
              bgcolor: 'rgba(211, 47, 47, 0.1)', 
              mr: 2,
              display: 'flex'
            }}
          >
            <BlockIcon sx={{ fontSize: 28, color: 'error.main' }} />
          </Box>
          <Typography variant="h5" fontWeight="bold" sx={{ fontFamily: '"Playfair Display", serif' }}>
            Restricciones de Uso
          </Typography>
        </Box>

        <Typography paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
          Se concede una licencia limitada para acceder y hacer uso personal de este sitio y no para descargar (excepto el almacenamiento en caché de páginas) o modificarlo, o cualquier parte del mismo, excepto con el consentimiento expreso por escrito de Blüm Art.
        </Typography>

        <List>
          <ListItem>
            <ListItemIcon>
              <BlockIcon color="error" fontSize="small" />
            </ListItemIcon>
            <ListItemText 
              primary="No está permitido el uso de minería de datos, robots o herramientas similares de recopilación y extracción de datos." 
              primaryTypographyProps={{ sx: { color: '#555' } }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <BlockIcon color="error" fontSize="small" />
            </ListItemIcon>
            <ListItemText 
              primary="No se permite reproducir, duplicar, copiar, vender, revender o explotar con fines comerciales ninguna parte de este servicio sin consentimiento expreso." 
              primaryTypographyProps={{ sx: { color: '#555' } }}
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box 
            sx={{ 
              p: 1.5, 
              borderRadius: '50%', 
              bgcolor: 'rgba(156, 39, 176, 0.1)', 
              mr: 2,
              display: 'flex'
            }}
          >
            <GavelIcon sx={{ fontSize: 28, color: 'secondary.main' }} />
          </Box>
          <Typography variant="h5" fontWeight="bold" sx={{ fontFamily: '"Playfair Display", serif' }}>
            Marcas Registradas
          </Typography>
        </Box>

        <Typography paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
          <strong>Blüm Art™</strong> y el logotipo de Blüm son marcas comerciales registradas. No pueden utilizarse en relación con ningún producto o servicio que no sea de Blüm, de ninguna manera que pueda causar confusión entre los clientes, o de ninguna manera que menosprecie o desacredite a Blüm.
        </Typography>

        <Box sx={{ mt: 6, textAlign: 'center', p: 4, bgcolor: '#f8f9fa', borderRadius: 4 }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} Blüm Art. Todos los derechos reservados.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Para consultas sobre permisos o uso de marca, contáctenos en <Link to="/support" style={{ color: '#e91e63', fontWeight: 600, textDecoration: 'none' }}>soporte@blum-art.mx</Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default CopyrightPage;
